import axios from "axios";

//axios.create能创造一个新的axios实例
const httpRequest = axios.create({
  timeout: 60000, //配置超时时间
  headers: {}//配置请求头
})


// interceptors为axios的拦截器 如果我们想要在请求以前做些什么 这个时候就需要用到拦截器  视业务需求而定
httpRequest.interceptors.request.use(function (config) {
  //非登录的请求都加上一个请求头
  config.headers.token = localStorage.getItem("token") || "";
  return config;
}, function (error) {
  return Promise.reject(error);
});


// /添加响应拦截器
httpRequest.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response.data
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default httpRequest



// WEBPACK FOOTER //
// ./src/network/http.js